export default __webpack_public_path__ + "assets/wasm/ammo.wasm-3a50d562f1ae5ec84690ec44f42e9c3d.wasm";